import { Breadcrumbs, CircularProgress, Dialog, DialogContent, Link } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import CustomDialogTitle from '../../CustomDialogTitle'
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Grid, Divider } from '@material-ui/core';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from '@material-ui/lab';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import HomeIcon from "@material-ui/icons/Home"; // Import a home icon for the first breadcrumb
import NavigateNextIcon from "@material-ui/icons/NavigateNext"; // Optional: Custom separator icon
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import UnitOperations from './ReportsComponent/UnitOperations';
import SamplesComponent from './ReportsComponent/SamplesComponent';
import BatchDetailsStepper from './ReportsComponent/BatchDetailsStepper';
import { presentFormatedData } from '../../../functionalComponents/dataFormatFunctions';
import moment from 'moment';
import ExceptionStepper from './ReportsComponent/ExceptionStepper';
import axios from 'axios';
import { appUrl } from '../../../../../../../utils/config';

const useStyles = makeStyles((theme) => ({
  timelineContainer: {
    padding: 0, // Remove padding
    margin: 0, // Remove margin
  },
  timeline: {
    paddingLeft: 0, // Remove padding to eliminate left space
  },
  timelineItem: {
    '&.MuiTimelineItem-missingOppositeContent:before': {
      display: 'none', // This removes the default ::before content
    },
  },
  timelineDot: {
    backgroundColor: '#1391C9',
    width: '30px',
    height: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  timelineContentBox: {
    padding: theme.spacing(1),
    // border: '1px solid #ddd',
    borderRadius: '8px',
    // backgroundColor: '#f9f9f9',
    marginBottom: theme.spacing(4),
  },
  stepTitle: {
    fontWeight: '600',
    fontSize: '20px',
  },
  separator: {
    backgroundColor: '#1391C9',
    width: '4px',
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  root: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    // width: '100%',
    // backgroundColor: '#EDEDED',
    '& .MuiStepLabel-label': {
      color: 'rgba(0, 0, 0, 0.87)',
      fontWeight: 500,
    },
  },
  table: {
    minWidth: 650,
  },
  tableContainer: {
      boxShadow: 'none', // Remove border and shadow from the container
      marginBottom:'3rem',
  },
  tableCell: {
    textAlign: 'left',
    backgroundColor: '#c2e1ef',
    borderBottom: 'none', // Remove bottom border
    // width: '16.666%', // Set equal width for each cell
    padding: '16px', // Standard padding for consistency
  },
  headerCell: {
    fontWeight: 'bold',
  },
}));


const ViewBatchStructuredReport = (props) => {
  const { openDialog, handleClose, batch } = props;
  const classes = useStyles();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const history = useHistory();
  const openProjectDashboard = () => {
    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/projectsdashboard`
    );
  };

  useEffect(() => {
    // setTimeout(() => {
    //   setData({
    //     plantID:82028222,
    //     gmpBatchNumber:'1',
    //     batchNumber:'DEF-IMCL-184226-DS-001',
    //     numberBMR:'BMR-IMCL-184226-DS',
    //     batchStartDate:'2024-02-24T09:20:00',
    //     batchEndDate:'2024-03-27T09:20:00',
    //   producedQuantity:515,
    //   uom:'KG',
    //     storageLocationID :'223', 
    //     storageLocationName:'Warehouse 2 - Shelf 14',
    //     storageCondition:'Ambient',
    //     expiryDate:'2024-05-27T09:20:00',
    //     CPPAndCQADetails :
    //       [
    //         {
    //       unitOperation : {
    //   procedureNumberStart: 22,
    //     procedureNumberEnd: 25,
    //   scheduledStartTime: '2024-02-24T09:20:00',
    //   scheduledEndTime:'2024-02-25T11:20:00',
    //     actualStartTime: '2024-03-24T14:40:00',
    //   actualEndTime:'2024-03-25T11:20:00',
    //   unitOperationStatus: 'completed',
    //   unitOperationID: 1,
    //   unitOperationName: 'REACTION',
    //   criticalProcessParameters:[
    //     { parameter: 'Temperature', upperLimit: 185, lowerLimit: 175, value: 187, uom: 'C' },
    //     { parameter: 'Volume', upperLimit: 2100, lowerLimit: 1950, value: 2000, uom: 'L' },
    //     { parameter: 'Chemical 1 Concentration', upperLimit: 12, lowerLimit: 5, value: 10, uom: 'g/L' },
    //   ]
    //   },
    //   qcSampling : {
    //   collabrixQCSamplingID:23,
    //   procedureNumber:2334,
    //   qcSamplingStatus: 'completed',
    // qcSamplingID: 1,
    // qcSamplingName: 'REACTION SAMPLE',
    // criticalQualityAttributes:[
    //   { parameter: 'Product Concentration', upperLimit: 750, lowerLimit: 500, value: 600, uom: 'g/L' },
    //   { parameter: 'Product Amount', upperLimit: 750, lowerLimit: 650, value: 700, uom: 'KG' },
    //   { parameter: 'Impurity 1 Concentration', upperLimit: 200, lowerLimit: 60, value: 50, uom: 'mg/L' },
    // ]
    // }
    //         },
  
    //         {
    //           unitOperation : {
    //       procedureNumberStart: 24,
    //         procedureNumberEnd: 26,
    //       scheduledStartTime: '2024-02-24T09:20:00',
    //       scheduledEndTime:'2024-02-25T11:20:00',
    //         actualStartTime: '2024-03-24T14:40:00',
    //       actualEndTime:'2024-03-25T11:20:00',
    //       unitOperationStatus: 'completed',
    //       unitOperationID: 2,
    //       unitOperationName: 'CENTRIFUGATION',
    //       criticalProcessParameters:[
    //         { parameter: 'Temperature', upperLimit: 186, lowerLimit: 176, value: 187, uom: 'C' },
    //         { parameter: 'Volume', upperLimit: 2101, lowerLimit: 1951, value: 2000, uom: 'L' },
    //         { parameter: 'Chemical 1 Concentration', upperLimit: 12, lowerLimit: 5, value: 10, uom: 'g/L' },
    //       ]
    //       },
    //       qcSampling : {
    //       collabrixQCSamplingID:23,
    //       procedureNumber:2334,
    //       qcSamplingStatus: 'completed',
    //     qcSamplingID: 2,
    //     qcSamplingName: 'Supernatant Sample',
    //     criticalQualityAttributes:[
    //       { parameter: 'Product Concentration', upperLimit: 751, lowerLimit: 501, value: 600, uom: 'g/L' },
    //       { parameter: 'Product Amount', upperLimit: 750, lowerLimit: 650, value: 700, uom: 'KG' },
    //       { parameter: 'Impurity 1 Concentration', upperLimit: 200, lowerLimit: 60, value: 50, uom: 'mg/L' },
    //     ]
    //     }
    //         },
    //         {
    //           unitOperation : {
    //       procedureNumberStart: 10,
    //         procedureNumberEnd: 66,
    //       scheduledStartTime: '2024-02-24T09:20:00',
    //       scheduledEndTime:'2024-02-25T11:20:00',
    //         actualStartTime: '2024-03-24T14:40:00',
    //       actualEndTime:'2024-03-25T11:20:00',
    //       unitOperationStatus: 'completed',
    //       unitOperationID: 3,
    //       unitOperationName: 'Rotary Vacuum Dryer',
    //       criticalProcessParameters:[
    //         { parameter: 'Temperature', upperLimit: 200, lowerLimit: 180, value: 187, uom: 'C' },
    //         { parameter: 'Volume', upperLimit: 2100, lowerLimit: 1950, value: 2000, uom: 'L' },
    //         { parameter: 'Chemical 1 Concentration', upperLimit: 12, lowerLimit: 5, value: 10, uom: 'g/L' },
    //       ]
    //       },
    //       qcSampling : {
    //       collabrixQCSamplingID:33,
    //       procedureNumber:2334,
    //       qcSamplingStatus: 'completed',
    //     qcSamplingID: 3,
    //     qcSamplingName: 'Dryer Sample',
    //     criticalQualityAttributes:[
    //       { parameter: 'Product Concentration', upperLimit: 600, lowerLimit: 400, value: 600, uom: 'g/L' },
    //       { parameter: 'Product Amount', upperLimit: 750, lowerLimit: 650, value: 700, uom: 'KG' },
    //       { parameter: 'Impurity 1 Concentration', upperLimit: 200, lowerLimit: 60, value: 50, uom: 'mg/L' },
    //     ]
    //     }
    //         },
    //         {
    //           unitOperation : {
    //       procedureNumberStart: 11,
    //         procedureNumberEnd: 33,
    //       scheduledStartTime: '2024-02-24T09:20:00',
    //       scheduledEndTime:'2024-02-25T11:20:00',
    //         actualStartTime: '2024-03-24T14:40:00',
    //       actualEndTime:'2024-03-25T11:20:00',
    //       unitOperationStatus: 'completed',
    //       unitOperationID: 4,
    //       unitOperationName: 'Powder Filling',
    //       criticalProcessParameters:[
    //         { parameter: 'Temperature', upperLimit: 185, lowerLimit: 175, value: 187, uom: 'C' },
    //         { parameter: 'Volume', upperLimit: 2100, lowerLimit: 1950, value: 2000, uom: 'L' },
    //         { parameter: 'Chemical 1 Concentration', upperLimit: 12, lowerLimit: 5, value: 10, uom: 'g/L' },
    //       ]
    //       },
    //       qcSampling : {
    //       collabrixQCSamplingID:23,
    //       procedureNumber:2334,
    //       qcSamplingStatus: 'completed',
    //     qcSamplingID: 4,
    //     qcSamplingName: 'Final Material Sample',
    //     criticalQualityAttributes:[
    //       { parameter: 'Product Concentration', upperLimit: 750, lowerLimit: 500, value: 600, uom: 'g/L' },
    //       { parameter: 'Product Amount', upperLimit: 750, lowerLimit: 650, value: 700, uom: 'KG' },
    //       { parameter: 'Impurity 1 Concentration', upperLimit: 200, lowerLimit: 60, value: 50, uom: 'mg/L' },
    //     ]
    //     }
    //             }
    //       ],
    //     reviewedExceptions: [
    //       {     // Based on BatchID 
    //     exceptionID:3838383,
    //     exceptionDescription:'Cleaning and preparation delay of Procedure step 3.1.3.1 and 3.1.3.2',
    //     creationDate:'2024-02-24T09:20:00',
    //     requireSponsorSMEReview:false,
    //     requireSponsorQAReview:true,
    //   impactOnProduct:"NO",
    //   exceptionSeverity:'Low'
    //       },
    //       {     // Based on BatchID 
    //         exceptionID:3838383,
    //         exceptionDescription:'Cleaning and preparation delay of Procedure step 3.1.3.1 and 3.1.3.2',
    //         creationDate:'2024-02-24T09:20:00',
    //         requireSponsorSMEReview:true,
    //         requireSponsorQAReview:true,
    //       impactOnProduct:"NO",
    //       exceptionSeverity:'Low'
    //       },
    //       {     // Based on BatchID 
    //         exceptionID:3838383,
    //         exceptionDescription:'Cleaning and preparation delay of Procedure step 3.1.3.1 and 3.1.3.2',
    //         creationDate:'2024-02-24T09:20:00',
    //         requireSponsorSMEReview:false,
    //         requireSponsorQAReview:false,
    //       impactOnProduct:"NO",
    //       exceptionSeverity:'Low'
    //       },
    //       {     // Based on BatchID 
    //         exceptionID:3838383,
    //         exceptionDescription:'Cleaning and preparation delay of Procedure step 3.1.3.1 and 3.1.3.2',
    //         creationDate:'2024-02-24T09:20:00',
    //         requireSponsorSMEReview:false,
    //         requireSponsorQAReview:false,
    //       impactOnProduct:"NO",
    //       exceptionSeverity:'Low'
    //           }
    //     ]
        
    //   }
    //   )
    //   setLoading(false)
      
    // },[5000])
    
    let data = {
      collabrixBatchID: batch.collabrixBatchID
    }
    //console.log(data)
    axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchBatchStructuredData`,
      data
    )
    .then((res) => {
      if (res.data.status) {
        setLoading(false)
        setData(res.data.data)
      } else {
        setLoading(false)
        setError(true)
      }
    })
        .catch((err) => {
          setError(true)
          setLoading(false)
          console.log(err)
        });
  }, [])
  
  const getLength = () => {
    let length = 0;
    if (data && Object.keys(data).length > 0 && data?.CPPAndCQADetails && data?.CPPAndCQADetails.length > 0) {
      for (let index = 0; index < data?.CPPAndCQADetails.length; index++) {
        if (data?.CPPAndCQADetails[index].unitOperation && Object.keys(data?.CPPAndCQADetails[index].unitOperation).length > 0) {
          length = length + 1;
        }
        if (data?.CPPAndCQADetails[index].qcSampling && Object.keys(data?.CPPAndCQADetails[index].qcSampling).length > 0) {
          length = length + 1;
        }
        
      }
      return length;
    } else {
      return length;
    }
  }

  return (
    <div><Dialog open={openDialog} fullScreen>
    <CustomDialogTitle
      onBackClick={handleClose}
      title={`Batch Number - ${batch.batchNumber}`}
    />
     
      <DialogContent>
      <Breadcrumbs
          separator={'/'}
          aria-label="breadcrumb"
          style={{ margin: "18px 0", color:'#2196f3'  }}
        >
          {/* Home link with an icon */}
          <Link
            // href="/"
            color="secondary"
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => openProjectDashboard()}
          >
            <HomeIcon fontSize="small" style={{ marginRight: "4px" }} />
          </Link>

          {/* Project Dashboard link */}
          <Link
            //   href="/projectdashboard"
            style={{ cursor: "pointer" }}
            color="secondary"
            onClick={() => openProjectDashboard()}
          >
            Project Dashboard
          </Link>

          {/* Project Name link */}
          <Link
            //   href={`/project/${projectData.projectName}`}
            style={{ cursor: "pointer" }}
            color="secondary"
          >
            Reports
          </Link>
          <Link
            //   href={`/project/${projectData.projectName}`}
            style={{ cursor: "pointer" }}
            color="secondary"
            onClick={() => handleClose()}
          >
            Structured Data
          </Link>

          {/* Final item as text (non-clickable) */}
          <Link
            //   href={`/project/${projectData.projectName}`}
            style={{ cursor: "pointer" }}
            color="secondary"
          >
           {batch.batchNumber}
          </Link>
        </Breadcrumbs>
        {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Horizontally center the CircularProgress
            alignItems: "center", // Vertically center the CircularProgress
            height: "100px", // Optional: Set a height to vertically center the loader
          }}
        >
          <CircularProgress />
        </div>
      ) : error ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Horizontally center the CircularProgress
            alignItems: "center", // Vertically center the CircularProgress
            height: "100px", // Optional: Set a height to vertically center the loader
            border: "2px solid #FF0000",
            backgroundColor: "#FFF0F0",
            width: "100%",
          }}
        >
          <Typography style={{ textAlign: "center" }}>
            Something went wrong. Please try again.
          </Typography>
        </div>
          ) : data ?
            (<>
            <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Plant ID</TableCell>
              <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>GMP Batch</TableCell>
              <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Batch Number</TableCell>
              <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>MBR number</TableCell>
              <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Start Date</TableCell>
                        {/* <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>End Date (expected)</TableCell> */}
                        <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>COA Decision Date</TableCell>
                        <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>COA Decision</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
                <TableCell className={classes.tableCell}>{presentFormatedData(data?.plantID)}</TableCell>
              <TableCell className={classes.tableCell}>{presentFormatedData(data?.gmpBatchNumber)}</TableCell>
              <TableCell className={classes.tableCell}>{presentFormatedData(data?.batchNumber)}</TableCell>
              <TableCell className={classes.tableCell}>{presentFormatedData(data?.numberBMR)}</TableCell>
              <TableCell className={classes.tableCell}>{data?.batchStartDate ? moment(data.batchStartDate).format('DD-MMM-YYYY').toUpperCase():' - '}</TableCell>
                        {/* <TableCell className={classes.tableCell}>{data?.batchEndDate ? moment(data.batchEndDate).format('DD-MMM-YYYY') : ' - '}</TableCell> */}
                        <TableCell className={classes.tableCell}>{data?.qaStatusUpdatedDate ? moment(data.qaStatusUpdatedDate).format('DD-MMM-YYYY').toUpperCase():' - '}</TableCell>
                        <TableCell className={classes.tableCell}>
                          {/* {presentFormatedData(data?.qaStatusText)} */}
                          {presentFormatedData("Approved")}
                        </TableCell>
                      </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
        <Timeline align="left" className={classes.timeline}>
          {data && data.CPPAndCQADetails.length > 0 && 
            data.CPPAndCQADetails.map((val, i) => (
              <>
                {val.unitOperation && Object.keys(val.unitOperation).length > 0 &&
                 <TimelineItem className={classes.timelineItem}>
                 <TimelineSeparator>
                           <TimelineDot className={classes.timelineDot}>{i+(i+1)}</TimelineDot>
                   <TimelineConnector className={classes.separator} />
                 </TimelineSeparator>
                 <TimelineContent>
                   <Box className={classes.timelineContentBox}>
                         <Typography className={classes.stepTitle}>{val.unitOperation.unitOperationName}</Typography>
                     <UnitOperations data={val.unitOperation} />
                   </Box>
                 </TimelineContent>
               </TimelineItem>
              }
          
                {val.qcSampling && Object.keys(val.qcSampling).length > 0 &&
                  <TimelineItem className={classes.timelineItem}>
                  <TimelineSeparator>
                    <TimelineDot className={classes.timelineDot}>{i+(i+2)}</TimelineDot>
                    <TimelineConnector className={classes.separator} />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Box className={classes.timelineContentBox}>
                      <Typography className={classes.stepTitle}>{val.qcSampling.qcSamplingName}</Typography>
                      <SamplesComponent data={val.qcSampling} />
                    </Box>
                  </TimelineContent>
                </TimelineItem>
                }
        
            </>
            ))
            
          }
      
          <TimelineItem className={classes.timelineItem}>
          <TimelineSeparator>
              <TimelineDot className={classes.timelineDot}>{getLength()+1}</TimelineDot>
            <TimelineConnector className={classes.separator} />
          </TimelineSeparator>
          <TimelineContent>
            <Box className={classes.timelineContentBox}>
                <Typography className={classes.stepTitle}>MATERIAL STORAGE</Typography>
                <BatchDetailsStepper data={data} />
            </Box>
          </TimelineContent>
                  </TimelineItem>
                  
                  {data.reviewedExceptions && data.reviewedExceptions.length > 0 && 
                  <TimelineItem className={classes.timelineItem}>
                  <TimelineSeparator>
                      <TimelineDot className={classes.timelineDot}>{getLength()+2}</TimelineDot>
                    <TimelineConnector className={classes.separator} />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Box className={classes.timelineContentBox}>
                        <Typography className={classes.stepTitle}>LIST OF REVIEWED EXCEPTIONS</Typography>
                        <ExceptionStepper data={data} />
                    </Box>
                  </TimelineContent>
                    </TimelineItem>
                  }
          

      {/* Additional Timeline Items */}
      
    </Timeline>
              </>) : (
                <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                  width: "100%",
                }}
              >
                <Typography style={{ textAlign: "center" }}>
                  No Records Found.
                </Typography>
              </div>
      )}
    </DialogContent>
  </Dialog></div>
  )
}

export default ViewBatchStructuredReport